import { useState, useEffect } from "react";

export function useIntroDialog() {
  const [showIntroDialog, setShowIntroDialog] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("utm_campaign") === "vkusno_tochka") {
      setShowIntroDialog(true);

      // Remove the utm_campaign param from the URL
      queryParams.delete("utm_campaign");
      const newQueryString = queryParams.toString();
      const newUrl =
        window.location.pathname + (newQueryString ? `?${newQueryString}` : "");
      window.history.replaceState(null, "", newUrl);
    }
  }, []);

  const closeDialog = () => setShowIntroDialog(false);

  return { showIntroDialog, closeDialog };
}
